import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_050.jpg';
page.paint = [
  {
    id: 'page025_game2',
    icon: 'ikona_cw2',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Połącz liniami obrazki robotów z nazwami miejsc, <br/>w których są one używane.  ',
      audio: 'files/page025/z25c2.mp3',
      item: {
        path: 'informatyka/files/page025/z.25cw.2.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 200,
    },
  },
  {
    id: 'page025_game3',
    icon: 'ikona_cw3',
    // tooltip: "Zaprogramuj animację (Scratch).",
    // tooltip: "page000_test24 TrInputOnBackgroundJims08",
    paintObj: {
      text: 'Połącz elementy rysunku.  ',
      audio: 'files/page025/z25c3.mp3',
      item: {
        path: 'informatyka/files/page025/z.25cw.3.bmp',
      },
      cssStyle: {
        width: '765px !important',
      },
    },
    pos: {
      x: LEFT,
      y: 400,
    },
  },
];
// page.word = [
//   {
//     id: 'page026_game3',
//     icon: 'ikona_cw3',
//     // tooltip: "Zaprogramuj animację (Scratch).",
//     // tooltip: "page000_test24 TrInputOnBackgroundJims08",
//     wordObj: {
//       text: 'Uzupełnij zdania. Kliknij w ikonę programu Word.',
//       audio: 'files/page026/z26c3.mp3',
//       item: {
//         path: 'informatyka/files/page026/26_ćw_3_word.docx',
//       },
//       cssStyle: {
//         width: '765px !important',
//       },
//     },
//     pos: {
//       x: LEFT,
//       y: 400,
//     },
//   },
// ];
page.games = [
  {
    id: 'page025_game1',
    tooltip: '',
    icon: 'ikona_cw1',
    pos: {
      x: LEFT,
      y: 0,
    },
  },
  // {
  //   id: 'page025_game2',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 200,
  //   },
  // },
  // {
  //   id: 'page019_game3',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 400,
  //   },
  // },
  // {
  //   id: 'page019_game4',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 600,
  //   },
  // },
  // {
  //   id: 'page010_game5',
  //   tooltip: '',
  //   icon: 'ikona_cw2',
  //   pos: {
  //     x: LEFT,
  //     y: 800,
  //   },
  // },
];
page.gallery = [
  {
    id: '_gallery1',
    icon: 'ikona_cw4',
    pos: {
      x: LEFT,
      y: 600,
    },
    items: [
      {
        imageSrc: 'gallery/page025/004.jpg',
        alt: 'Roboty',
        dataDescription: 'Obrazki robotów ',
      },
      {
        imageSrc: 'gallery/page025/007.jpg',
        alt: 'Roboty',
        dataDescription: 'Obrazki robotów ',
      },
      {
        imageSrc: 'gallery/page025/006.jpg',
        alt: 'Roboty',
        dataDescription: 'Zabawki Lego Mindstorms EV3',
      },
      {
        imageSrc: 'gallery/page025/005.jpg',
        alt: 'Roboty',
        dataDescription: 'Buduję robota ',
      },
      {
        imageSrc: 'gallery/page025/015.jpg',
        alt: 'Roboty',
        dataDescription: 'Buduję robota ',
      },
      {
        imageSrc: 'gallery/page025/014.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot-zabawka',
      },
      {
        imageSrc: 'gallery/page025/019.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot-pies ',
      },
      {
        imageSrc: 'gallery/page025/012.jpg',
        alt: 'Roboty',
        dataDescription: 'Zabawa z robotem',
      },
      {
        imageSrc: 'gallery/page025/013.jpg',
        alt: 'Roboty',
        dataDescription: 'Rodzina robotów',
      },
      {
        imageSrc: 'gallery/page025/010.jpg',
        alt: 'Roboty',
        dataDescription: 'Mikołajki u robotów ',
      },
      {
        imageSrc: 'gallery/page025/001.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot w fabryce',
      },
      {
        imageSrc: 'gallery/page025/002.jpg',
        alt: 'Roboty',
        dataDescription: 'Linia produkcyjna z robotami',
      },
      {
        imageSrc: 'gallery/page025/008.jpg',
        alt: 'Roboty',
        dataDescription: 'Sterowanie robotami w fabryce',
      },
      {
        imageSrc: 'gallery/page025/011.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot Pepper (czytaj peper, czyli Pieprz) ',
      },
      {
        imageSrc: 'gallery/page025/003.jpg',
        alt: 'Roboty',
        dataDescription: 'Witaj, Pepper! ',
      },
      {
        imageSrc: 'gallery/page025/009.jpg',
        alt: 'Roboty',
        dataDescription: 'Operacja z pomocą robota',
      },
      {
        imageSrc: 'gallery/page025/016.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot w szklarni',
      },
      {
        imageSrc: 'gallery/page025/018.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot zbiera owoce',
      },
      {
        imageSrc: 'gallery/page025/017.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot w ogrodzie',
      },
      {
        imageSrc: 'gallery/page025/020.jpg',
        alt: 'Roboty',
        dataDescription: 'Robot pomaga starszym',
      },
    ],
  },
];
page.images = [
  {
    imageId: 'page050_zoom2',
    rectangle: {
      x: 175,
      y: 300,
      width: 400,
      height: 400,
    },
    imageSrc: 'images/page050/050_0.jpg',
  },
  {
    imageId: 'page050_zoom0',
    rectangle: {
      x: 0,
      y: 700,
      width: 1920,
      height: 1400,
    },
    imageSrc: 'images/page050/050 1.jpg',
  },
  {
    imageId: 'page050_zoom1',
    rectangle: {
      x: 0,
      y: 1500,
      width: 1920,
      height: 900,
    },
    imageSrc: 'images/page050/050 2.jpg',
  },
];
export default page;
